export const PAGE_STATES = {
  RENEWAL_OFFER: 'RENEWAL_OFFER',
  LINK_EXPIRED: 'LINK_EXPIRED',
  INVALID_LINK: 'INVALID_LINK',
  ALREADY_COMPLETED: 'ALREADY_COMPLETED',
  TEMPORARY_ERROR: 'TEMPORARY_ERROR',
  AUTH_REQUIRED: 'AUTH_REQUIRED',
};

// Mirrors wobi-auto-service's POLICY_TYPES, as emitted in policy.coverType.
export const COVER_TYPES = {
  FULLCOVER: 'FULLCOVER',
  THIRD_PARTY: '3RDPARTY',
};

export const SCREENS = {
  LOADING: 'LOADING',
  AUTH: 'AUTH',
  OFFER: 'OFFER',
  PAYMENT: 'PAYMENT',
  SIGNING_PENDING: 'SIGNING_PENDING',
  COMPLETION: 'COMPLETION',
  EXPIRED: 'EXPIRED',
  INVALID: 'INVALID',
  ERROR: 'ERROR',
};

// postMessage type sent from the DocuSign return tab back to the renewal tab.
export const SIGNING_RESULT_MESSAGE = 'renewalClick:signing-result';

// DocuSign appends ?event=<outcome> to the returnUrl.
export const DOCUSIGN_EVENT = {
  SIGNING_COMPLETE: 'signing_complete',
  CANCEL: 'cancel',
  DECLINE: 'decline',
};

// Reported by the signing tab when it could not obtain a DocuSign session.
export const SIGNING_SESSION_FAILED_EVENT = 'session_failed';

// SSE events published by wobi-auto-service on the 'renewal-click' namespace.
export const SIGNING_SSE_EVENT = {
  COMPLETED: 'signing-completed',
  FINALIZATION_FAILED: 'signing-finalization-failed',
};

export const mapPageStateToScreen = (pageState) => {
  switch (pageState) {
  case PAGE_STATES.RENEWAL_OFFER:
    return SCREENS.OFFER;
  case PAGE_STATES.LINK_EXPIRED:
    return SCREENS.EXPIRED;
  case PAGE_STATES.INVALID_LINK:
    return SCREENS.INVALID;
  case PAGE_STATES.ALREADY_COMPLETED:
    return SCREENS.COMPLETION;
  case PAGE_STATES.TEMPORARY_ERROR:
    return SCREENS.ERROR;
  case PAGE_STATES.AUTH_REQUIRED:
    return SCREENS.AUTH;
  default:
    return SCREENS.ERROR;
  }
};

export const screenToStepIndex = (screen) => {
  switch (screen) {
  case SCREENS.OFFER:
    return 0;
  case SCREENS.PAYMENT:
    return 1;
  case SCREENS.SIGNING_PENDING:
    return 2;
  case SCREENS.COMPLETION:
    return 3;
  default:
    return -1;
  }
};

// Central Renewal Click journey-activity vocabulary — keep in sync with
// wobi-auto-service's src/constants/renewalJourneyActivity.js.
export const RENEWAL_JOURNEY_NAME = 'Renewal_In_Click';

export const RenewalJourneyEvent = {
  OFFER_DETAILS_OPENED: 'renewal_click_offer_details_opened',
  OFFER_CONFIRMED: 'renewal_click_offer_confirmed',
  REACHED_PAYMENT: 'renewal_click_reached_payment',
  PAYMENT_COMPLETED: 'renewal_click_payment_completed',
  REACHED_SIGNATURE: 'renewal_click_reached_signature',
  SUBMITTED: 'renewal_click_submitted',
  CONTACT_CLICKED: 'renewal_click_contact_clicked',
};

export const RenewalJourneyLocation = {
  OFFER: 'offer',
  PAYMENT: 'payment',
  SIGNATURE: 'signature',
  COMPLETION: 'completion',
};
